export enum HelpLanguage {
  SV = "sv",
  EN = "en",
}
